var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43985 8.81874C4.94771 9.29049 4.29572 9.54855 3.60168 9.54855L3.6006 9.54854C2.16516 9.54854 1 8.4286 1 7.05566V3.35512C1 2.78458 1.48164 2.32289 2.07683 2.32289C2.67202 2.32289 3.15366 2.78458 3.15366 3.35512V7.05566C3.15366 7.29357 3.35558 7.48409 3.6006 7.48409C3.71943 7.48409 3.83301 7.43771 3.91608 7.35808L11.2762 0.302799C11.6958 -0.0994091 12.3804 -0.102454 12.8 0.302799C13.2196 0.708052 13.2196 1.36125 12.8 1.76345L5.43985 8.81874ZM3.20105 14.2369L10.5612 7.18165C11.0533 6.70989 11.7053 6.45184 12.3994 6.45184C13.8348 6.45184 15 7.57178 15 8.94472V12.6453C15 13.2158 14.5183 13.6775 13.9231 13.6775C13.3279 13.6775 12.8463 13.2158 12.8463 12.6453V8.94472C12.8463 8.70682 12.6444 8.5163 12.3994 8.5163C12.2805 8.5163 12.1669 8.56267 12.0839 8.6423L4.72374 15.6976C4.51448 15.8992 4.24 16 3.96239 16C3.68584 16 3.41137 15.8992 3.20105 15.6976C2.78146 15.2923 2.78146 14.6391 3.20105 14.2369Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIcon1);
export default __webpack_public_path__ + "static/media/solution_icon_1.64530f6c52973818273a675d84b7d110.svg";
export { ForwardRef as ReactComponent };